import { render, staticRenderFns } from "./phoneForm.vue?vue&type=template&id=7ed9de86&scoped=true&"
import script from "./phoneForm.vue?vue&type=script&lang=js&"
export * from "./phoneForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneForm.vue?vue&type=style&index=0&id=7ed9de86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed9de86",
  null
  
)

export default component.exports